module.exports = __webpack_public_path__ + "static/stamp-eatella-qr-ordering-71b4e9416c8900d764530cdbe4119dea.png";